// copy & paste
export const contentCopyHandler = (content, sourceUrl, event) => {
  const clipboardData = event?.clipboardData || window.clipboardData
  if (!window?.getSelection || !clipboardData) {
    return
  }
  const selection = window?.getSelection() || ''
  if (String(selection).trim().length <= 2) {
    return
  }
  const defaultContent = '文章版權為無綫集團有限公司所擁有，原文請按﹕'
  const text = String(selection)
  clipboardData.setData('text/plain', `${text}\r\n\r\n${content || defaultContent} ${sourceUrl}`)

  clipboardData.setData(
    'text/html',
    `${text}<br/><br/>${content || defaultContent} <a href="${sourceUrl}" target="_blank">${sourceUrl}</a>`
  )
  event.preventDefault()
}
